var $3d6c378c9a42cfd9$exports = {};
$3d6c378c9a42cfd9$exports = {
    "more": `Vi\u{161}e stavki`
};


export {$3d6c378c9a42cfd9$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
